// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap"; 

// import commerical1 from "../../assets/chd-protected-1.png";
// import commerical2 from "../../assets/chd-protected-2.png";
// import commerical3 from "../../assets/chd-protected-3.png";
// import commerical4 from "../../assets/chd-protected-4.png";
// import commerical5 from "../../assets/chd-protected-5.png";
// import commerical6 from "../../assets/chd-protected-6.png";


// export default function CommercialHorticultureProtected() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Commercial Horticulture Development in protected cover on project mode from NHB</h1>
//                                  <p>(a) Activity (ies) allowed and Area norms: The Board will also take up commercial horticulture development projects under protected cover on project mode including components viz planting material, plantation, irrigation, fertigation, mechanization, etc for projects having area over 2500 sq meter. In case of NE Region, projects having area over 1000 sq meter are eligible. Activities like construction of green houses, shade net house, plastic mulching, and plastic tunnel, anti bird /hail nets etc would be promoted. Provision has been made for selecting a variety of construction material for green houses and shade nets houses. Preference will be given to using locally available material to minimize cost of construction of such structures. In case of flowers, projects will be considered only under Green House structures.</p>

//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                 <p>(b) Crops eligible:</p>
//                                 <p>a. Flowers: Anthurium, Orchids, Rose, Lilium, Chrysanthemum, Carnation and Gerbera.</p>
//                                 <p>b. Vegetables: High value vegetables: Capsicum, Cucumber, Tomato</p>
//                                 <p>(c) Pattern of assistance: Credit linked back-ended subsidy @ 50% of the total project cost limited to Rs 56.00 lakh per project as per admissible cost norms for green houses, shade net house, plastic tunnel, anti bird /hail nets & cost of planting material etc</p>
//                                 <p>(d) Maximum Project costs allowed for subsidy calculation.</p>
                                  
//                                   <img src={commerical1} alt="Commercial Horticulture" className="img-fluid b-block mx-auto mb-3" />
                              
//                                   <p className="align-items-center">e. Cost norms for Protected cultivation under NHB Scheme:</p>
//                                   <img src={commerical2} alt="Commercial Horticulture" className="img-fluid b-block mx-auto mb-3" />
                              
//                                   <p>* Cost of Tubular structure in plain area. In hilly States, cost of poly house will be 15% more.</p>

//                                   <h2>Note:</h2>
//                                   <p>1 Wherever cost norms are not given, cost norms available under MIDH scheme for similar activity shall be followed. In case norms are not available under MIDH scheme also, cost appraised by bank as per bank norms or approved by Competent committee of NHB shall apply till cost norms are prepared.</p>
//                                   <p>2 In project mode, applicant may opt for add on components as per norms given 1.1. (f) but unless otherwise specified, cost ceiling, as prescribed for each crop/activity shall be applied where cost of add on components exceeds prescribed ceiling.</p>
//                                   <p>(f).Norms for Technology Add on components and other essential components of Integrated Commercial Horticulture projects.</p>
                              
//                                   <img src={commerical3} alt="Commercial Horticulture" className="img-fluid b-block mx-auto mb-3" />
//                               <img src={commerical4} alt="Commercial Horticulture" className="img-fluid b-block mx-auto mb-3" />

//                              <p>Components categorization:</p>
//                              <p>* Commercial Horticulture, within overall cost ceiling</p>
//                              <p># Protected Cultivation, within overall cost ceiling</p>
//                              <p>## Over and above overall cost ceiling</p>
//                              <p>Any other add on component as may be decided by Project Approval Committee for inclusion of new item(s) may be suitably incorporated from time to time.</p>
//                              <p>(g)Technical Standards: For availing subsidy, all material /technology should strictly conform to the prescribed standards, else the project is not eligible for any financial assistance.</p>
                              
//                                   <h2>g. (i)TECHNICAL STANDARDS OF NATURALLY VENTILATED POLY HOUSE (NVPH)</h2>
//                                   <img src={commerical5} alt="Commercial Horticulture" className="img-fluid b-block mx-auto mb-3" />
                                  
//                                   <h2 className="align-items-center">g.(ii).TECHNICAL STANDARDS OF SHADE NET HOUSE</h2>
//                                   <img src={commerical6} alt="Commercial Horticulture" className="img-fluid b-block mx-auto mb-3" />
                              
                              
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>    
//   );
// };



import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaGlobe,
  FaList,
  FaIndustry,
  FaRocket,
  FaHandsHelping
} from "react-icons/fa";

export default function CommercialHorticultureProtected() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4">
            <Col lg={12}>
              <h1>
                Commercial Horticulture – Protected Cultivation (NHB)
              </h1>

              <p>
                The NHB scheme promotes high-value horticulture through protected
                cultivation systems such as polyhouses, shade net houses, and tunnels.
              </p>

              <p>
                It enables higher yield, better quality produce, and year-round farming
                with reduced climatic risks.
              </p>
            </Col>
          </Row>

          {/* OBJECTIVE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Objective of the Scheme
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Increase productivity with controlled farming</li>
            <li><FaCheckCircle /> Promote high-value crops</li>
            <li><FaCheckCircle /> Reduce climate risks</li>
            <li><FaCheckCircle /> Encourage agri-tech adoption</li>
            <li><FaCheckCircle /> Improve export-quality production</li>
          </ul>

          {/* WHAT IS */}
          <h2 className="section-title">
            <FaList className="icon" /> What is Protected Cultivation
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Polyhouses (natural / fan & pad)</li>
            <li><FaCheckCircle /> Shade net houses</li>
            <li><FaCheckCircle /> Plastic tunnels</li>
            <li><FaCheckCircle /> Anti-hail & anti-bird systems</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Project Size & Eligibility
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 2500 sq.m (general areas)</li>
            <li><FaCheckCircle /> 1000 sq.m (NE & hilly areas)</li>
            <li><FaCheckCircle /> Farmers & entrepreneurs</li>
            <li><FaCheckCircle /> Companies & FPOs</li>
            <li><FaCheckCircle /> Cooperatives</li>
          </ul>

          {/* CROPS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Crops Covered
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Flowers: Rose, Gerbera, Carnation, Orchid</li>
            <li><FaCheckCircle /> Vegetables: Capsicum, Tomato, Cucumber</li>
          </ul>

          {/* SUBSIDY */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Pattern of Assistance
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 50% subsidy of project cost</li>
            <li><FaCheckCircle /> Maximum ₹56 Lakhs</li>
            <li><FaCheckCircle /> Credit-linked subsidy</li>
          </ul>

          {/* COST */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Cost Norms
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Based on structure type</li>
            <li><FaCheckCircle /> Depends on crop & technology</li>
            <li><FaCheckCircle /> Higher cost in hilly areas</li>
          </ul>

          {/* STRUCTURES */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Types of Structures
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Naturally ventilated polyhouse</li>
            <li><FaCheckCircle /> Fan & pad systems</li>
            <li><FaCheckCircle /> Shade net houses</li>
            <li><FaCheckCircle /> Plastic tunnels</li>
          </ul>

          {/* TECH */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Technology Add-ons
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Drip irrigation & fertigation</li>
            <li><FaCheckCircle /> Mulching</li>
            <li><FaCheckCircle /> Fogging & misting</li>
            <li><FaCheckCircle /> Automation systems</li>
          </ul>

          {/* INFRA */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Infrastructure Support
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Pack houses</li>
            <li><FaCheckCircle /> Storage & grading units</li>
            <li><FaCheckCircle /> Labour rooms</li>
            <li><FaCheckCircle /> Vermicompost units</li>
          </ul>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Benefits
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 2–5x higher yield</li>
            <li><FaCheckCircle /> Better quality produce</li>
            <li><FaCheckCircle /> Year-round farming</li>
            <li><FaCheckCircle /> Water efficiency</li>
            <li><FaCheckCircle /> Higher market price</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide complete support including DPR preparation,
            bank loan assistance, subsidy application, NHB coordination, and project execution.
          </p>

          {/* WHY */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Why Choose Us
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Strong NHB expertise</li>
            <li><FaCheckCircle /> High approval success rate</li>
            <li><FaCheckCircle /> Customized project planning</li>
            <li><FaCheckCircle /> Transparent process</li>
            <li><FaCheckCircle /> End-to-end support</li>
          </ul>

        </Container>
      </section>
    </div>
  );
}
